(function() {
    'use strict';

    angular
        .module('corePRUGAGreatApp')
        .controller('AppController', AppController);

    AppController.$inject = ['$scope', '$state', '$window', '$base64', 'Auth', 
                             'Principal', 'LoginService', 'GLOBAL_URL', 'Account', 
                             'CommonService', 'EVENT', 'AlertService', '$rootScope', '$stateParams','AppExportService','$timeout', 'MASTER_CONST'];

    function AppController($scope, $state, $window, $base64, Auth, 
    		Principal, LoginService, GLOBAL_URL, Account, CommonService, EVENT, AlertService, $rootScope, $stateParams, AppExportService,$timeout, MASTER_CONST) {
        var vm = this;
        $rootScope.MASTER_CONST = MASTER_CONST;
        vm.currentDate = new Date();
        vm.lasBusinessDate = null;
        vm.isAuthenticated = Principal.isAuthenticated;
        
        vm.login = login;
        vm.logout = logout;
        vm.changeOffice = changeOffice;
        vm.currentOffice = null;
        vm.$state = $state;
           
        vm.isCollapsed1 = true;
        vm.isCollapsed2= true;
        vm.isCollapsed3 = true;
        vm.isCollapsed4 = true;
        vm.isCollapsed5 = true;
        vm.isCollapsed6 = true;
        vm.isCollapsed7 = true;
        vm.isCollapsed8 = true;
        vm.isCollapsed9 = true;
        vm.isCollapsed10 = true;
        vm.getLASBusinessDate = getLASBusinessDate;
        vm.stateReload = stateReload;
        
        vm.isNew = false;
        
        function stateReload() {
        	$state.transitionTo($state.current, $stateParams, {
        	      reload: true, inherit: false, notify: true 
        	});
        };
        
        function login() {
            LoginService.open();
        };

        function logout() {
            Auth.logout();
            $window.open(GLOBAL_URL, '_self');
        };
        
        function changeOffice() {
        	if (vm.currentOffice) {
        		$scope.clearMessage();
	        	Account.post(vm.currentOffice, 
	        		function(result) {
	        		vm.account = result;
	                vm.isAuthenticated = Principal.isAuthenticated;
	                vm.currentOffice = result.currentOffice;
	                $scope.addAlert('Hệ thống đã được chuyển sang văn phòng [' + result.currentOffice.officeCode + ' - ' + result.currentOffice.officeName + ']', 'success');
	                $scope.$broadcast(EVENT.changeOffice, vm.currentOffice);
	        	});
        	}
        };
        
        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
            	/*if(account.inactive > 0) {
            		vm.logout();
            		return;
            	}*/
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                if(Principal.isAuthenticated()) {
                	//vm.init();
                }
                if (account) {
                	if (!account.currentOffice) {
                		$scope.addAlert('Thông tin tổng văn phòng không tìm thấy.', 'warning');
                	}
                	vm.currentOffice = account.currentOffice;
                	getLASBusinessDate();
                	var to = $rootScope.toState;
                	if (to.name === 'login') {
                		$window.open(GLOBAL_URL + 'menu/', '_self');
                	}
                }
            });
        };
        
        function getLASBusinessDate() {
        	/*CommonService.returnValue({masterurl:'las-business-date'}, function(data) {
        		vm.lasBusinessDate = data.response;
        	});*/
        };
        
        $rootScope.exportToExcel=function(tableId,sheetName){ // ex: '#my-table'
        	var sheet = sheetName == null || sheetName == undefined ? 'Sheet1':sheetName;
        	var prefixFile = '.xls';
			var exportHref = AppExportService.tableToExcel(tableId,sheet);
			var byteCharacters = atob(exportHref);
			var byteNumbers = new Array(byteCharacters.length);
			for (var i = 0; i < byteCharacters.length; i++) {
			    byteNumbers[i] = byteCharacters.charCodeAt(i);
			}
			var byteArray = new Uint8Array(byteNumbers);
			var blob=new Blob([byteArray], { type: 'data:application/vnd.ms-excel;charset=utf-8' });
			$timeout(function(){
				if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for IE browser
					$window.navigator.msSaveBlob(blob, sheetName + prefixFile);
		       }else {
		    	   var fileURL = $window.URL.createObjectURL(blob);
    	    	   // Test tren chorme va firefox
  	    		 	var theAnchor = $('<a />')  
				        .attr('href', fileURL)  
				        .attr('download',sheetName + prefixFile)
				         .appendTo('body');
	 			    theAnchor[0].click();   
	 			    theAnchor.remove();  
    	       }
				
			},100); // trigger download
           
        }
    }
})();
